import type { UseFormReturn } from 'react-hook-form';
import { Labeled, TextInputField } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IUserContentReviewModerateFormValues } from './UserContentReviewModerateForm';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';

export type IUserContentReviewModerateFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<IUserContentReviewModerateFormValues>;
};

export const UserContentReviewModerateFormMainSection: React.FC<
  IUserContentReviewModerateFormMainSectionProps
> = (props) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled
        label={t(
          'UserContentReviewModerateFormMainSection.fields.reason.label',
        )}
        supportingText={t(
          'UserContentReviewModerateFormMainSection.fields.reason.supportingText',
        )}
      >
        <FormField
          name="reason"
          control={form.control}
          as={TextInputField}
          forwardError
        />
      </Labeled>
    </FormSection>
  );
};
